import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useDispatch } from "react-redux";
import { confirmInvitation } from "../redux/slice/invitations";
import { useCustomDispatch } from "./hooks/useCustomDispatch";

const MySwal = withReactContent(Swal);

export const showOrderDeleteConfirmation = () => {
  return MySwal.fire({
    title: "Confirmar",
    text: "¿Está seguro que desea eliminar la orden?. Esta acción no se podrá revertir",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const successOrderDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se eliminó la orden correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showOrderEmailConfirmation = (email, callback) => {
  MySwal.fire({
    title: "Reenviar confirmación",
    text: `¿Está seguro que desea enviar la confirmación a: ${email}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Si, reenviar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const addTranslateConfirmation = (callback) => {
  MySwal.fire({
    title: "Agregar Traducción",
    text: `¿Está seguro que desea agregar una nueva traducción?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Si, crear",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const removeTranslateConfirmation = (callback) => {
  MySwal.fire({
    title: "Eliminar Traducción",
    text: `¿Está seguro que desea eliminar esta traducción?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Si, eliminar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successOrderEmail = (email) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: `Se ha reenviado correctamente a: ${email}`,
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorResendEmail = (email) => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: `No se pudo reenviar a: ${email}`,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });
};

export const showSpeiReminderConfirmation = (email, callback) => {
  MySwal.fire({
    title: "Enviar recordatorio",
    text: `¿Está seguro que desea enviar el recordatorio de pago a: ${email}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Si, reenviar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successSpeiReminder = (email) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: `Se ha enviar el recordatorio a: ${email}`,
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showTicketValidationConfirmation = (callback) => {
  MySwal.fire({
    title: "Validar Ticket",
    text: `¿Está seguro que desea validar el Ticket?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Si, validar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successTicketValidation = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: `Se ha validado el Ticket`,
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showConfirmOrderConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea confirmar esta orden? Si ya esta pagada, se actualizará.",
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successConfirmOrder = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se ha confirmado la orden",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorConfirmOrder = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Error al confirmar la orden, intentelo más tarde.",
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });
};

export const showDoubleConfirmOrderConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "La orden aún no ha sido pagada, ¿Está seguro que desea confirmar esta orden?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const showGenerateInvoiceConfirmation = (email, rfc, callback) => {
  MySwal.fire({
    title: "Confirmación",
    html: `<input value=${email} placeholder='correo@mail.com' />
    <input value=${rfc} placeholder='RFC' />
    and other HTML tags`,
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successGenerateInvoice = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se ha emitido la factura. Llegará al correo que se ingresó.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showResentInvoiceConfirmation = (email, callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: `¿Está seguro que desea enviar la factura a: ${email}? Si deseas que llegue a otro correo, entra a Detalles.`,
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successResentInvoice = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se ha reenviado la factura.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showRoleDeleteConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "¿Está seguro que quiere eliminar este Rol?. Esta acción no se podrá revertir.",
    icon: "error",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successRoleDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Rol eliminado correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorRoleDelete = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Error al eliminar el boleto. Intentelo nuevamente.",
    customClass: {
      confirmButton: "btn btn-primary",
    },
  });
};

export const successRoleCreated = (message) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Rol creado correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorRoleCreated = (message) => {
  MySwal.fire({
    icon: "error",
    title: "Error",
    text: `${
      message
        ? "Este nombre ya se encuentra en uso."
        : "Error al crear rol. Revise los datos e intentelo más tarde."
    }`,
    customClass: {
      confirmButton: "btn btn-primary",
    },
  });
};

export const showTicketDeleteConfirmation = () => {
  return MySwal.fire({
    title: "Confirmar",
    text: "¿Está seguro que desea eliminar el boleto?. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const showSpeakersDeleteConfirmation = () => {
  return MySwal.fire({
    title: "Confirmar",
    text: "¿Está seguro que desea eliminar al Speaker?. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const showReservDeleteConfirmation = (callback) => {
  return MySwal.fire({
    title: "Confirmar",
    text: "¿Está seguro que desea eliminar la reservación?. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const successReservationDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se eliminó la reservación correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const successTicketDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se eliminó el boleto correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const successSpeakersDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "El Speaker fue borrado con éxito.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const successConferencessDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "La conferencia fue borrada con éxito.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showTicketCheckInConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea cambiar el Check-in del ticket?",
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successTicketCheckIn = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se cambió el Check-in del ticket. Espere en lo que aparece la impresión del ticket",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorTicketCheckIn = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Hubo un incidente al actualizar el Check-in. Intente de nuevo.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showTicketResentConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea reenviar el boleto?",
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const showCertificateResentConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea reenviar la constancia?",
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successTicketResent = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se reenvió el boleto correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const successCertificateResent = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se reenvió la constancia correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorTicketResent = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Hubo un incidente al reenviar el boleto. Intente nuevamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorCertificateResent = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Hubo un incidente al reenviar la constancia. Intente nuevamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorTicketDelete = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Error al eliminar el boleto. Intentelo nuevamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorReservationDelete = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Error al eliminar la reservación. Intentelo nuevamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorOrderDelete = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Error al eliminar la orden. Intentelo nuevamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showUserDeleteConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea eliminar al usuario? Esta acción no se podrá revertir.",
    icon: "error",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successUserDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se eliminó el usuario correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const successUserCreated = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Usuario creado correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorUserCreated = (status) => {
  const message =
    status === 1012
      ? "El correo ya se encuentra vinculado a un usuario"
      : "Intentelo nuevamente";
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: `Error. ${message}.`,
    customClass: {
      confirmButton: "btn btn-primary",
    },
  });
};

export const showCouponDeleteConfirmation = (callback) => {
  return MySwal.fire({
    title: "Confirmar",
    text: "¿Está seguro que desea eliminar el cupón?. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const successCouponDelete = (callback) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se eliminó el cupón correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  }).then((result) => {
    if (result.value) {
      // callback
    }
  });
};

export const errorCouponsDelete = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Hubo un problema al eliminar el cupón. Intente nuevamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showSubscriptionDeleteConfirmation = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea eliminar la suscripción?. Esta acción no se podrá revertir.",
    icon: "error",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const successSubscriptionDelete = () => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "Se eliminó exitosamente la suscripción.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const errorSubscriptionsDelete = () => {
  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: "Hubo un problema al eliminar la suscripción. Intente nuevamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const showConfirmCheckIn = (callback) => {
  MySwal.fire({
    title: "Confirmación",
    text: " Esta a punto de hacer Check In. Presiona Ok para confirmar",
    icon: "warning",
    showDenyButton: true,
    confirmButtonText: "OK",
    denyButtonText: "Cancelar",
    customClass: {
      actions: "my-actions",
      confirmButton: "order-1 btn btn-primary me-1",
      denyButton: "order-3 btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.isDenied) {
      return false;
    }
    if (result.value) {
      callback();
    }
  });
};

export const successCheckIn = (extraText) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: extraText ? `Check In exitoso. ${extraText}` : "Check In exitoso.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  }).then((result) => {
    if (result.isConfirmed) {
    }
  });
};

export const errorCheckIn = (e) => {
  const message = `${
    e
      ? e === 4001
        ? "Este asistente ya ha hecho Check In."
        : "No se puede hacer Check In, el boleto no ha sido pagado."
      : "Ocurrió un problema hacer Check In. Intente lo nuevamente."
  }`;

  MySwal.fire({
    icon: "error",
    title: "Atención",
    text: message,
    customClass: {
      confirmButton: "btn btn-error",
    },
  });
};

export const rePrintBadgeConfirmation = (callback) => {
  MySwal.fire({
    icon: "warning",
    title: "Atención",
    text: "Ya ha sido impreso un gafete, si continua se invalidara el gafete anterior y se generará uno nuevo.",
    showDenyButton: true,
    denyButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-success me-1",
      denyButton: "btn btn-outline-danger ml-1",
    },
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const errordeliverKit = (name) => {
  MySwal.fire({
    icon: "warning",
    title: "Atención",
    text: `Este kit se entrego a: ${name}`,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });
};

export const massiveDownloadConfirmation = (callback) => {
  MySwal.fire({
    icon: "warning",
    title: "Atención",
    text: `Esta función te permite descargar constancias tomando en cuenta los filtros aplicados a la busqueda, 
    por lo cual esto puede demorar algunos minutos.`,
    showDenyButton: true,
    denyButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-success me-1",
      denyButton: "btn btn-danger ml-1",
    },
  }).then((result) => {
    if (result.isDenied) {
    }
    if (result.value) {
      callback();
    }
  });
};

export const deleteTicketSwal = async (
  id,
  eventId,
  callback,
  setRefresh,
  refresh
) => {
  return showTicketDeleteConfirmation()
    .then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        await callback(id, eventId);
        successTicketDelete();
        if (refresh === undefined) {
        } else {
          setRefresh(!refresh);
        }
      }
    })
    .catch((e) => {
      Swal.close();
    });
};

export const deleteSpeakersSwal = async (
  id,
  eventId,
  callback,
  setRefresh,
  refresh
) => {
  return showSpeakersDeleteConfirmation()
    .then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        await callback(id, eventId);
        successSpeakersDelete();
        if (refresh === undefined) {
        } else {
          setRefresh(!refresh);
        }
      }
    })
    .catch((e) => {
      Swal.close();
    });
};

export const deleteConferencesSwal = async (
  id,
  eventId,
  callback,
  setRefresh,
  refresh
) => {
  return showSpeakersDeleteConfirmation()
    .then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        await callback(id, eventId);
        successConferencessDelete();
        if (refresh === undefined) {
        } else {
          setRefresh(!refresh);
        }
      }
    })
    .catch((e) => {
      Swal.close();
    });
};

export const deleteOrderSwal = async (
  id,
  eventId,
  callback,
  refresh,
  setRefresh
) => {
  return showOrderDeleteConfirmation()
    .then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
        });
        await callback(id, eventId);
        successOrderDelete();
        if (refresh === undefined) {
        } else {
          setRefresh(!refresh);
        }
      }
    })
    .catch((e) => {
      Swal.close();
    });
};

export const deleteReservationSwal = async (
  id,
  eventId,
  callback,
  setRefresh,
  refresh
) => {
  return showReservDeleteConfirmation()
    .then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        await callback(id, eventId);
        successReservationDelete();
        if (refresh === undefined) {
        } else {
          setRefresh(!refresh);
        }
      }
    })
    .catch((e) => {
      Swal.close();
    });
};

export const deleteCouponSwal = async (
  id,
  eventId,
  callback,
  setRefresh,
  refresh
) => {
  return showCouponDeleteConfirmation()
    .then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await callback(id, eventId);
        successCouponDelete();
        if (refresh === undefined) {
        } else {
          setRefresh(!refresh);
        }
      }
    })
    .catch((e) => {
      Swal.close();
    });
};

export const showConfirmInvitationConfirmation = (callback) => {
  return MySwal.fire({
    title: "Confirmar",
    text: "¿Está seguro que desea confirmar la invitación?. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    customClass: {
      confirmButton: "btn btn-success me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const successConfirmInvitation = (callback) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "La invitación ha sido confirmada correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  }).then((result) => {
    if (result.value) {
    }
  });
};

export const errorConfirmInvitation = () => {
  MySwal.fire({
    icon: "warning",
    title: "Atención",
    text: `No se pudo confirmar la invitación, inténtelo más tarde.`,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });
};

export const confirmInvitationsSwal = async (
  id,
  eventId,
  callback,
  dispatch,
  refresh,
  setRefresh
) => {
  if (typeof dispatch !== "function") {
    console.error("Error: dispatch is not a function");
    return;
  }
  if (typeof callback !== "function") {
    console.error("Error: callback is not a function");
    return;
  }
  return showConfirmInvitationConfirmation()
    .then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        dispatch(callback({ eventId, id }))
          .unwrap()
          .then(() => {
            Swal.close();
            setRefresh(!refresh);
            successConfirmInvitation();
          })
          .catch((err) => {
            console.log("error : ", err);
            Swal.close();
            errorConfirmInvitation();
          });
      } else {
        console.log("object no");
      }
    })
    .catch((e) => {
      console.log("eerrr : ", e);
    });
};

export const showDeclineInvitationConfirmation = (callback) => {
  return MySwal.fire({
    title: "Declinar",
    text: "¿Está seguro que desea declinar la invitación?. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    customClass: {
      confirmButton: "btn btn-success me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const successDeclineInvitation = (callback) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "La invitación ha sido confirmada correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  }).then((result) => {
    if (result.value) {
    }
  });
};

export const errorDeclineInvitation = () => {
  MySwal.fire({
    icon: "warning",
    title: "Atención",
    text: `No se pudo confirmar la invitación, inténtelo más tarde.`,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });
};

export const declineInvitationsSwal = async (
  id,
  eventId,
  callback,
  dispatch,
  refresh,
  setRefresh
) => {
  if (typeof dispatch !== "function") {
    console.error("Error: dispatch is not a function");
    return;
  }
  if (typeof callback !== "function") {
    console.error("Error: callback is not a function");
    return;
  }
  return showDeclineInvitationConfirmation()
    .then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        dispatch(callback({ eventId, id }))
          .unwrap()
          .then(() => {
            Swal.close();
            setRefresh(!refresh);
            successDeclineInvitation();
          })
          .catch((err) => {
            console.log("error : ", err);
            Swal.close();
            errorDeclineInvitation();
          });
      } else {
        console.log("object no");
      }
    })
    .catch((e) => {
      console.log("eerrr : ", e);
    });
};

export const showDeleteExhibitorsConfirmation = (callback) => {
  return MySwal.fire({
    title: "Eliminar",
    text: "¿Está seguro de eliminar al Expositor?. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    customClass: {
      confirmButton: "btn btn-success me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

export const successDeleteExhibitor = (callback) => {
  MySwal.fire({
    icon: "success",
    title: "Éxito",
    text: "El expositor ha sido eliminado correctamente.",
    customClass: {
      confirmButton: "btn btn-success",
    },
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

export const errorDeleteExhibitor = () => {
  MySwal.fire({
    icon: "warning",
    title: "Atención",
    text: `No se pudo eliminar al expositor, inténtelo de nuevo más tarde.`,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });
};

export const deleteExhibitorSwal = async (
  id,
  eventId,
  callback,
  dispatch,
  goBack
) => {
  return showDeleteExhibitorsConfirmation()
    .then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Cargando",
          text: "Porfavor espere...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        dispatch(callback({ eventId, id }))
          .unwrap()
          .then(() => {
            Swal.close();
            successDeleteExhibitor(goBack);
          })
          .catch((err) => {
            console.log("error : ", err);
            Swal.close();
            errorDeleteExhibitor();
          });
      } else {
        console.log("object no");
      }
    })
    .catch((e) => {
      console.log("eerrr : ", e);
    });
};

export const showOrderValidateConfirmation = () => {
  return MySwal.fire({
    title: "Confirmar",
    text: "A continuación se realizará la validación de las órdenes. Esta acción no se podrá revertir.",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Confirmar",
    customClass: {
      confirmButton: "btn btn-primary me-1",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  });
};

const amountFormat = (a) => {
  const resultd = a.toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
  });
  return resultd;
};

export const successValidate = (amount) => {
  return MySwal.fire({
    icon: "question",
    title: "Ahora",
    text: `Se realizara el depósito por la cantidad de: ${amountFormat(
      amount / 100
    )} ¿Desea continuar?`,
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
};

export const successDep = () => {
  MySwal.fire({
    icon: "success",
    title: "Exito",
    text: `Se realizo el depósito correctamente.`,
    customClass: {
      confirmButton: "btn btn-success me-1",
    },
  });
};

export const validateOrder = async (
  args,
  callback,
  callbackDep,
  dispatch,
  refresh,
  setRefresh,
  toggleCleared,
  setToggleCleared
) => {
  return showOrderValidateConfirmation()
    .then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: "Espera...",
          text: "Estamos validando las ordenes...",
          allowOutsideClick: false,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: false,
          allowEscapeKey: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        dispatch(callback(args))
          .unwrap()
          .then((e) => {
            Swal.close();
            successValidate(e?.data?.amount)
              .then((res) => {
                if (res.value) {
                  Swal.fire({
                    title: "Espera...",
                    text: "Estamos realizando el deposito...",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    showCancelButton: false,
                    showCloseButton: false,
                    allowEscapeKey: false,
                    onOpen: () => {
                      Swal.showLoading();
                    },
                  });
                  dispatch(callbackDep(args))
                    .unwrap()
                    .then((el) => {
                      Swal.close();
                      successDep();
                      setRefresh(!refresh);
                      setToggleCleared(!toggleCleared);
                    })
                    .catch((e) => {
                      console.log("error : ", e);
                    });
                }
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((err) => {
            console.log("error : ", err);
            Swal.close();
            errorDeclineInvitation();
          });
      }
    })
    .catch((e) => {
      Swal.close();
    });
};
